 var swiper = new Swiper(".video-slider", {
  slidesPerView: 4,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 1.40,
      spaceBetween: 15
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 3.3,
      spaceBetween: 20
    }
  }
});